// store/modules/im/status.js
const state = {
    pulloffMsgState: new Map(),
    timeOut: null,
    reConnection: 3
};

const mutations = {
    SET_PULLOFF_MSG_STATE(state, { sessionId, canPull }) {
        state.pulloffMsgState.set(sessionId, canPull);
    },
    SET_TIMEOUT(state, timer) { state.timeOut = timer; },
    SET_RECONNECTION(state, count) { state.reConnection = count; }
};

export default {
    namespaced: true,
    state,
    mutations
};